module.exports = __webpack_public_path__ + "static/media/certificateofconformityfront.5eb9f62d.jpg";